
const Skill = ({ title, percent }) => {
  return (
    <>
      <div className='row align-items-center mb-2'>
        <div className='col'><h6>{title}</h6></div>
        <div className='col-auto text-muted'>{percent}%</div>
      </div>
      <div className="progress" role="progressbar" style={{ height: '7px'}} aria-label="Default striped example" aria-valuenow={percent} aria-valuemin="0" aria-valuemax="100">
        <div className="progress-bar bg-primary-gradient" style={{width: percent + '%'}}></div>
      </div>
    </>
  );
}

export default Skill;